import React from 'react';
import { NextPage } from 'next';
import loadNamespaces from 'next-translate/loadNamespaces';
import { prefetchRafflesOrContests } from '../../api';

import { withAuthSync } from '../../utils/auth';

import RaffleOverview from '../../components/Contest/Overview';
import { createQueryCacheState } from '../../utils/ssr/prefetch';
import { VirpPageContext } from '../_app';

const RaffleOverviewPage: NextPage = () => <RaffleOverview filter="contest" />;

RaffleOverviewPage.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/raffles',
  });

  return {
    ...(await createQueryCacheState(
      prefetchRafflesOrContests({
        page: 1,
        filter: 'contest',
      }),
    )),
    ...getTranslations,
  };
};

export default withAuthSync(RaffleOverviewPage);
